<template>
  <div class="form-container editform-container">
    <h1>鳥獣被害編集</h1>
    <form>
      <table class="wildlife-list-edit-table">
        <tbody>
          <!-- 共通項目 -->
          <tr>
            <td><label for="no"><strong>受付番号</strong></label></td>
            <td><strong>:</strong></td>
            <td><input id="no" :value="editableData.no" type="text" disabled class="text" /></td>
          </tr>
          <tr>
            <td><label for="id"><strong>利用者ID</strong></label></td>
            <td><strong>:</strong></td>
            <td><input id="id" :value="editableData.id" type="text" disabled class="text" /></td>
          </tr>
          <tr>
            <td><label for="name"><strong>氏名</strong></label></td>
            <td><strong>:</strong></td>
            <td><input id="name" v-model="editableData.nameKanji" type="text" disabled class="text" />
            </td>
          </tr>
          <tr>
            <td><label for="type"><strong>種別</strong></label></td>
            <td><strong>:</strong></td>
            <td><input id="type" :value="typeLabel(editableData.type)" type="text" disabled class="text" /></td>
          </tr>

          <!-- 被害特有の項目 -->
          <tr v-if="isDamageType">
            <td><label for="damageArea"><strong>被害面積(㎡)</strong></label></td>
            <td><strong>:</strong></td>
            <td><input id="damageArea" v-model="editableData.damageArea" type="text" class="text" />
            <span v-if="errors.damageArea" class="error-message">{{ errors.damageArea }}</span>
            </td>
          </tr>
          <tr v-if="isDamageType">
            <td><label for="damageAmount"><strong>被害金額(円)</strong></label></td>
            <td><strong>:</strong></td>
            <td><input id="damageAmount" v-model="editableData.damageAmount" type="text" class="text" />
            <span v-if="errors.damageAmount" class="error-message">{{ errors.damageAmount }}</span>
            </td>
          </tr>

          <!-- 捕獲特有の項目 -->
          <tr v-if="isSightType">
            <td><label for="length"><strong>体長(㎝)</strong></label></td>
            <td><strong>:</strong></td>
            <td><input id="length" v-model="editableData.length" type="text" class="text" />
            <span v-if="errors.length" class="error-message">{{ errors.length }}</span>
            </td>
          </tr>
          <tr v-if="isSightType">
            <td><label for="totalWeight"><strong>体重(kg)</strong></label></td>
            <td><strong>:</strong></td>
            <td><input id="totalWeight" v-model="editableData.totalWeight" type="text" class="text" />
            <span v-if="errors.totalWeight" class="error-message">{{ errors.totalWeight }}</span>
            </td>
          </tr>

          <!-- その他共通項目 -->
          <tr>
            <td><label for="animalType"><strong>獣種</strong></label></td>
            <td><strong>:</strong></td>
            <td>
               <select id="animalType" v-model="editableData.animalType" type="text" class="text">
               <option disabled value="">選択してください</option>
               <option v-for="type in animalTypes" :key="type.value" :value="type.value">{{ type.label }}</option>
               </select>
            </td>
          </tr>
          <tr>
            <td><label for="byAnimal"><strong>幼成獣別</strong></label></td>
            <td><strong>:</strong></td>
            <td>
               <select id="byAnimal" v-model="editableData.byAnimal" type="text" class="text">
               <option disabled value="">選択してください</option>
               <option v-for="type in juvenileTypes" :key="type.value" :value="type.value">{{ type.label }}</option>
               </select>
            </td>
          </tr>
          <tr>
            <td><label for="municipalities"><strong>確認場所</strong></label></td>
            <td><strong>:</strong></td>
            <td>
              <input
                id="municipalities"
                v-model="municipalityInput"
                placeholder="都道府県 市区町村 地区"
                type="text"
                disabled 
                class="text"
              />
            </td>
          </tr>
          <tr>
            <td><label for="damageDate"><strong>日時</strong></label></td>
            <td><strong>:</strong></td>
            <td><input id="damageDate" v-model="editableData.damageDate" type="datetime-local" class="text" />
            <span v-if="errors.damageDate" class="error-message">{{ errors.damageDate }}</span>
            </td>
          </tr>
          <tr>
            <td><label for="count"><strong>頭数</strong></label></td>
            <td><strong>:</strong></td>
            <td>
               <select id="count" v-model="editableData.count" type="text" class="text">
               <option disabled value="">選択してください</option>
               <option v-for="type in headCountTypes" :key="type.value" :value="type.value">{{ type.label }}</option>
               </select>
            </td>
          </tr>
          <tr>
            <td><label for="sex"><strong>性別</strong></label></td>
            <td><strong>:</strong></td>
            <td>
            <select id="sex" v-model="editableData.sex"  type="text" class="text">
            <option disabled value="">選択してください</option>
            <option v-for="type in genderTypes" :key="type.value" :value="type.value">{{ type.label }}</option>
            </select>
            </td>
          </tr>

          <!-- 画像フィールド -->
          <tr>
            <td><strong>画像</strong></td>
            <td><strong>:</strong></td>
              <td>
                <img :src="editableData.imageUrl" :alt="editableData.imageUrl" style="max-width: 100px;" />
                <img :src="editableData.imageUrl1" :alt="editableData.imageUrl1" style="max-width: 100px;" />
                <img :src="editableData.imageUrl2" :alt="editableData.imageUrl2" style="max-width: 100px;" />
              </td>
          </tr>
          <tr>
            <td><label for="addNote"><strong>追記事項</strong></label></td>
            <td><strong>:</strong></td>
            <td><textarea id="addNote" v-model="editableData.addNote" class="text"></textarea>
            <span v-if="errors.addNote" class="error-message">{{ errors.addNote }}</span>
            </td>
          </tr>
          <tr>
            <td><label for="location"><strong>緯度/経度</strong></label></td>
            <td><strong>:</strong></td>
            <td>
              <input
                id="location-latitude"
                :value="editableData.locationLat || '不明'"
                placeholder="緯度"
                type="text"
                disabled 
                class="text"
              />
              <strong>/</strong>
              <input
                id="location-longitude"
                :value="editableData.locationLon || '不明'"
                placeholder="経度"
                type="text"
                disabled 
                class="text"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </form>
    <div class="edit-button-group">
      <button type="submit" @click="validateAndSaveChanges" class="update-button">更新</button>
      <button type="button" @click="cancelEdit" class="cancel-button">キャンセル</button>
    </div>
  </div>
</template>

<script>
import "@/assets/styles/Wildlife-edit-table.css";
import axios from "axios";
export default {
  data() {
    const data = this.$route.query.data
      ? JSON.parse(decodeURIComponent(this.$route.query.data))
      : {};
    return {
      editableData: data,
      isDamageType: data.type === "1",
      isSightType: data.type === "2",
      municipalityInput: "", // 初期値を空に設定
      errors: {}, // エラーオブジェクトを追加
      animalTypes: [
        { value: "01", label: "イノシシ"},
        { value: "02", label: "ニホンジカ"}, 
        { value: "03", label: "クマ"}, 
        { value: "04", label: "サル"}, 
        { value: "05", label: "タヌキ"}, 
        { value: "06", label: "アナグマ"}, 
        { value: "07", label: "ハクビシン"}, 
        { value: "08", label: "アライグマ"}, 
        { value: "09", label: "ヌートリア"}, 
        { value: "10", label: "鳥類"}, 
        { value: "11", label: "その他"}
      ],
      headCountTypes: [
        { value: "1", label: "1" },
        { value: "2", label: "2" },
        { value: "3", label: "3" },
        { value: "4", label: "4" },
        { value: "5", label: "5以上" },
        { value: "6", label: "不明" },
      ],
      genderTypes: [
        { value: "1", label: "オス"}, 
        { value: "2", label: "メス"}, 
        { value: "3", label: "オスとメス"}, 
        { value: "4", label: "不明"}
      ],
      juvenileTypes: [
        { value: "1", label: "幼獣"}, 
        { value: "2", label: "成獣"}, 
        { value: "3", label: "幼獣と成獣"}, 
        { value: "4", label: "不明"}
      ],
    };
  },
  created() {
      // 初期値を結合して設定
    const  municipalities = this.editableData.municipalities || "";
    const strAdd = this.editableData.strAdd || "";
    this.municipalityInput = `${municipalities} ${strAdd}`.trim(); // 不要な空白を削除
    if (this.editableData.damageDate) {
      const date = new Date(this.editableData.damageDate);
      date.setTime(date.getTime() + 9 * 60 * 60 * 1000); // 日本時間に調整（9時間をミリ秒で加算）

      // datetime-local用にフォーマット (YYYY-MM-DDTHH:MM)
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      this.editableData.damageDate = `${year}-${month}-${day}T${hours}:${minutes}`;
    }
  },
  methods: {
    // 種別変換
    typeLabel(data) {
      const damageLabels = {
       "1": "被害",
       "2": "捕獲",
       "3": "目撃",
       "4": "痕跡",
       "5": "わな",
       "9": "その他"
      }

      return damageLabels[data];
    },
    validateForm() {
      const errors = {};

      // 必須項目のエラーチェック
      if (!this.editableData.damageDate) errors.damageDate = "日時は必須です";
      
      // 桁数とバリデーションチェック
      // 被害面積(㎡)
      if (this.editableData.damageArea && !/^(\d{1,9}(\.\d{1,2})?)$/.test(this.editableData.damageArea)) {
        errors.damageArea = "被害面積(㎡)は整数部9桁、小数部2桁までで入力してください";
      }
      // 被害金額(円)
      if (this.editableData.damageAmount && (this.editableData.damageAmount < 0 || this.editableData.damageAmount.toString().length > 12)) {
        errors.damageAmount = "被害金額(円)は0以上、12桁までで入力してください";
      }
      // 体長(㎝)
      if (this.editableData.length && !/^(\d{1,3}(\.\d{1,2})?)$/.test(this.editableData.length)) {
        errors.length = "体長(㎝)は整数部3桁、小数部2桁までで入力してください";
      }
      // 体重(kg)
      if (this.editableData.totalWeight && !/^(\d{1,14}(\.\d{1,2})?)$/.test(this.editableData.totalWeight)) {
        errors.totalWeight = "体重(kg)は整数部14桁、小数部2桁までで入力してください";
      }
      // 追記事項
      if (this.editableData.addNote && this.editableData.addNote.length > 1000) {
        errors.addNote = "追記事項は1000桁以内で入力してください";
      }

      this.errors = errors;
      return Object.keys(errors).length === 0;
    },
    async validateAndSaveChanges() {
      if (this.validateForm()) {
        this.saveChanges();
      } else {
        // バリデーションエラーがある場合にポップアップで警告を表示
        alert('入力エラーがあります。');
      }
    },
    async saveChanges() {
      let storedAdmins = JSON.parse(localStorage.getItem('adminAgencies')) || [];
      storedAdmins.push(this.newAdmin);
      localStorage.setItem('adminAgencies', JSON.stringify(storedAdmins));

      // JWTトークンを取得
      const token = localStorage.getItem("jwtToken");
      if (!token) {
        alert("ログインしていません。再度ログインしてください。");
        return;
      }

      // セッションストレージから userId を取得
      const userId = localStorage.getItem("userId");
      if (!userId) {
        alert("ログイン情報が見つかりません。再度ログインしてください。");
        return;
      }
      // datetime-localの値を取得
      const inputDateTime = this.editableData.damageDate;
      // Dateオブジェクトとして作成（ローカルタイムとして解釈される）
      const localDate = new Date(inputDateTime);
      // ISO形式に変換してフロントエンドから送信
      const adjustedDateTime = localDate.toISOString().slice(0, 16); // "YYYY-MM-DDTHH:MM"形式に調整

      try {
        // サーバーに送信するデータをJSONに加工
        const dataToSubmit = {
          region_Id: this.editableData.region_Id || null,
          no: this.editableData.no || null,
          id: this.editableData.id || null,
          type: this.editableData.type || null,
          damageArea: this.editableData.damageArea || null,
          damageAmount: this.editableData.damageAmount || null,
          length: this.editableData.length || null,
          totalWeight: this.editableData.totalWeight || null,
          animalType: this.editableData.animalType || null,
          byAnimal: this.editableData.byAnimal || null,
          municipalities: this.municipalityInput || null,
          damageDate: adjustedDateTime || null,
          count: this.editableData.count || null,
          sex: this.editableData.sex || null,
          addNote: this.editableData.addNote || null,
          locationLat: this.editableData.locationLat || null,
          locationLon: this.editableData.locationLon || null,
          modifierId: userId || null,
          modifyDate: null,
        };

        for (const [key, value] of Object.entries(dataToSubmit)) {
          if (value === undefined) {
            dataToSubmit[key] = "";  // undefinedの場合は空文字に設定
          }
        }

        // APIリクエスト送信
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/wildlifeDamage/update`,
          dataToSubmit,
          {
            headers: {
              Authorization: `Bearer ${token}`, // JWTトークンを送信
            },
          }
        );

        // ステータスコード200の場合（送信成功）
        if (response.status === 200) {
          // 新しいトークンがレスポンスヘッダーに含まれている場合
          const newToken = response.headers.get('Authorization');
          if (newToken) {
              localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
          }
          alert("データが正常に登録されました。");
          this.$router.push(-1); // 必要に応じて遷移
        }
      } catch (error) {
        // エラーハンドリング
        if (error.response && error.response.status === 400) {
          alert(error.response.data.message || "リクエストにエラーがあります。");
        } else if (error.response && error.response.status === 401) {
          alert("認証エラー: ログイン情報を確認してください。");
        } else if (error.response && error.response.status === 500) {
          alert("サーバーエラーが発生しました。しばらくしてからお試しください。");
        } else {
          alert("ネットワークエラーが発生しました。接続を確認してください。");
        }
        console.error("送信エラー:", error);
      }
    },
    cancelEdit() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
</style>
